import "./k";
import "./data";
import "./scenes/loading";
import "./scenes/start";
import "./scenes/levelSelect";
import "./scenes/levelLoading";
import "./scenes/levelIntro";
import "./scenes/quiz";
import "./scenes/end";

loadRoot("./");
loadFont("rumeur", "fonts/Rumeur.otf", { filter: "linear" });

add([sprite("bg"), pos(-8, -8), stay()]);

usePostEffect("filmic", { u_intensity: 2.5 });
go("loading");
